export enum LANGUAGE_KEY {
  ENTRY_EXCEEDS_LENGTH_LIMIT = 'ENTRY_EXCEEDS_LENGTH_LIMIT',
  SHERPATH_AI_MATERIALS_LABEL = 'SHERPATH_AI_MATERIALS_LABEL',
  SHERPATH_AI_EBOOK_LABEL = 'SHERPATH_AI_EBOOK_LABEL',
  VALUE_REQUIRED = 'VALUE_REQUIRED',
}
